import { theme as defaultTheme } from 'stylist'
import Color from 'color'

export default theme => {
  if (!theme) {
    return defaultTheme
  }
  const normalizedTheme = { ...defaultTheme }

  normalizedTheme.fvStyle.brand.lightBrandGreen = theme.primaryColor
  normalizedTheme.fvStyle.brand.lighterBrandGreen = Color(theme.primaryColor)
    .darken(0.2)
    .string()
  normalizedTheme.fvStyle.brand.slate =
    theme.secondaryColor || normalizedTheme.fvStyle.brand.black
  normalizedTheme.fvStyle.brand = { ...normalizedTheme.fvStyle.brand, ...theme }

  return normalizedTheme
}



// WEBPACK FOOTER //
// ../src/utils/normalizeTheme.js